<template>
  <div class="user-avatar-dropdown dis-flex align-center">
    <Dropdown @on-click="handleClick">
      <div class="dis-flex align-center">
        <Icon size="24" type="md-contact" />
        <div
          class="dis-flex flex-wrap"
          style="line-height: 24px; white-space: nowrap"
        >
          {{ `${username}` }} {{ operate_area ? `<${operate_area}>` : "" }}
        </div>
      </div>

      <DropdownMenu slot="list">
        <DropdownItem name="zh">中文</DropdownItem>
        <DropdownItem name="en">English</DropdownItem>
        <DropdownItem name="accountInformation"
          >{{ $t("components.user.accountInformation") }}
        </DropdownItem>

        <DropdownItem name="logout"
          >{{ $t("components.user.signOut") }}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <!-- 账号信息弹窗 zjy s -->
    <Modal
      @on-ok="closeAccountInfo"
      class="hide-zindex-model hide-load-btn"
      :loading="modalLoading"
      v-model="modalAccount"
      :title="$t('components.user.accountInformation')"
    >
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("components.accountInfo.username") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          {{ accountInfo.username }}
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">{{ $t("components.accountInfo.role") }}:</div>
        <div class="box_content fl" style="width: 200px">
          {{ accountInfo.role }}
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("components.accountInfo.operatingArea") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          {{ accountInfo.area_name }}
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("components.accountInfo.quotaGift") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          {{ accountInfo.gift_use }} / {{ accountInfo.gift }}
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("components.accountInfo.quotaProp") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          {{ accountInfo.prop_use }} / {{ accountInfo.prop }}
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("components.accountInfo.quotaGold") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          {{ accountInfo.gold_use }} / {{ accountInfo.gold }}
        </div>
      </div>
      <!-- <h1>123zjy</h1> -->
      <!-- <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("views.invitationMessage.text10") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          <Input v-model="detail.invite_no"></Input>
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("views.invitationMessage.text11") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          <Input v-model="detail.user_no"></Input>
          <div style="color: red">
            {{ $t("views.giftInformation.toastText") }}
          </div>
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("views.invitationMessage.text5") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          <Input v-model="detail.binding_reason"></Input>
        </div>
      </div>
      <div class="box_all clear">
        <div class="box_title fl">
          {{ $t("views.invitationMessage.text7") }}:
        </div>
        <div class="box_content fl" style="width: 200px">
          <Input v-model="detail.principal"></Input>
        </div>
      </div> -->
    </Modal>

    <!-- zjy e -->
  </div>
</template>

<script>
import "./user.less";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      username: JSON.parse(localStorage.getItem("login_username")) || [],
      operate_area: JSON.parse(localStorage.getItem("operate_area")) || null,
      modalLoading: true,
      modalAccount: false,
      accountInfo: {
        username: "",
        role: "",
        area_name: "",
        gift: "",
        gold: "",
        prop: "",
      },
    };
  },
  name: "User",
  props: {
    userAvatar: {
      type: String,
      default: "",
    },
    messageUnreadCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    ...mapActions(["handleLogOut"]),
    //  async   getLogin(){
    // await this.$http.login()
    //     },
    logout() {
      this.$http.loginOut().then((res) => {
        this.$localStore.set("token", "");
        this.$localStore.set("login_uid", "");
        this.$localStore.set("login_username", "");
        this.$localStore.set('authList', '');
        this.$router.push({
          name: "login",
        });
        // 清空权限的缓存
        this.$store.commit("SETPUBLICSIDEMENU", []);
      });
    },

    zh() {
      console.log("点击中文");
      this.$i18n.locale = "zh-cn";
      this.$store.commit("SETLOCALE", "zh-cn");
    },
    en() {
      this.$i18n.locale = "en";
      this.$store.commit("SETLOCALE", "en");
    },
    accountInformation() {
      console.log("查询账号信息");
      this.$http.uidInfo().then((res) => {
        console.log(res, "账号信息");
        this.accountInfo = res.data;
        this.modalAccount = true;
        // this.$localStore.set("token", "");
        // this.$localStore.set("login_uid", "");
        // this.$localStore.set("login_username", "");
        // this.$router.push({
        //   name: "login",
        // });
        // // 清空权限的缓存
        // this.$store.commit("SETPUBLICSIDEMENU", []);
      });
    },
    closeAccountInfo() {
      this.modalAccount = false;
    },
    message() {
      this.$router.push({
        name: "message_page",
      });
    },
    handleClick(name) {
      switch (name) {
        case "logout":
          this.logout();
          break;
        case "message":
          this.message();
          break;
        case "zh":
          this.zh();
          break;
        case "en":
          this.en();
          break;
        case "accountInformation":
          this.accountInformation();
          break;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue